export default __webpack_public_path__ + "static/incentive-bg--medium-up-a4b1adda5e75138b0468be57e8d9404a.png";